/**
 * ext-components-pro
 *
 * Adapptio: Set of pro components
 *
 * @package ext-components-pro
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { codeMirror as codeMirrorComponent } from "./editor/components/codeMirror";
import { customChart as customChartEditorComponent } from "./editor/components/customChart";
import { customComponent as customComponentComponent } from "./editor/components/customComponent";
import { customHtml as customHtmlEditorComponent } from "./editor/components/customHtml";

import { customChart as customChartEditorSchema } from "./editor/schemas/customChart";
import { customHtml as customHtmlEditorSchema } from "./editor/schemas/customHtml";

export const termsEditor = {
	components: {
		customChart: customChartEditorComponent,
		customHtml: customHtmlEditorComponent,
		customComponent: customComponentComponent,
		codeMirror: codeMirrorComponent
	},

	schemas: {
		customChart: customChartEditorSchema,
		customHtml: customHtmlEditorSchema
	}
};

export const termsRuntime = {
	components: {}
};
